import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import type { AdminSettingChanges } from '@api/admin-settings';
import { formatValue } from '../utils/settings';

interface Props {
  changes: AdminSettingChanges | undefined;
  page: number;
  onPage: (page: number) => void;
}

const valueCell = { whiteSpace: 'pre-wrap', wordBreak: 'break-word' } as const;

/** Who changed which setting, when, from what to what. Newest first. */
function ChangeLog({ changes, page, onPage }: Props) {
  if (!changes) return null;
  if (!changes.results.length) {
    return (
      <Typography variant="body2" sx={{ color: '#475467' }}>
        No setting has been changed yet.
      </Typography>
    );
  }
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Table size="small" aria-label="Change log">
        <TableHead>
          <TableRow>
            <TableCell>When</TableCell>
            <TableCell>Setting</TableCell>
            <TableCell>Who</TableCell>
            <TableCell>Old value</TableCell>
            <TableCell>New value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {changes.results.map((change) => (
            <TableRow key={change.id}>
              <TableCell>
                {new Date(change.changed_at).toLocaleString()}
              </TableCell>
              <TableCell>{change.label}</TableCell>
              <TableCell>{change.changed_by || 'Unknown'}</TableCell>
              <TableCell sx={valueCell}>
                {formatValue(change.old_value)}
              </TableCell>
              <TableCell sx={valueCell}>
                {formatValue(change.new_value)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {(changes.previous || changes.next) && (
        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
          <Button
            size="small"
            disabled={!changes.previous}
            onClick={() => onPage(page - 1)}
          >
            Newer
          </Button>
          <Button
            size="small"
            disabled={!changes.next}
            onClick={() => onPage(page + 1)}
          >
            Older
          </Button>
        </Stack>
      )}
    </Box>
  );
}

export default ChangeLog;
